module.exports = {
  js: require("./questions/javascript"),
  css: require("./questions/css"),
};
